module.exports = __webpack_public_path__ + "static/media/desktop_2.93cea528.png";